import React from "react";
import { PropTypes } from "prop-types";

import { Grid } from "@mui/material";

import {
  datetime2FormattedString,
  string2Datetime,
} from "../../../shared/utils/utils";
import Table from "../../../react_utils/table/Table";

export default function LocationActivities({ location, resetParent }) {
  if (!location) return null;

  return (
    <Grid
      xs={12}
      sm={12}
      md={12}
      item
      justifyContent="center"
      alignItems="center"
    >
      <Table
        columns={[
          { name: "", key: "timestamp" },
          { name: "Nutzer", key: "user" },
          { name: "Aktivität", key: "name" },
          { name: "Beschreibung", key: "description" },
        ]}
        rows={location.activity_set.map((activity) => ({
          timestamp: datetime2FormattedString(
            string2Datetime(activity.timestamp),
          ),
          user: activity.user_name,
          description: activity.description,
          name: activity.name,
        }))}
      />
    </Grid>
  );
}

LocationActivities.propTypes = {
  location: PropTypes.object,
  resetParent: PropTypes.func,
};
